<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6 12.0406L12.6666 13.134M17 6.88097C16.9997 6.60822 16.9277 6.34034 16.7912 6.10421C16.6547 5.86807 16.4585 5.67198 16.2222 5.5356L11.4822 2.84194C10.5631 2.31961 9.4369 2.31961 8.51777 2.84194L3.77778 5.5356C3.54154 5.67198 3.34532 5.86807 3.2088 6.10421C3.07229 6.34034 3.00028 6.60822 3 6.88097V12.1639C3 13.2266 3.56228 14.2101 4.47815 14.7492L8.49737 17.1151C9.42636 17.6619 10.5773 17.6683 11.5123 17.1318L15.4931 14.8475C16.4252 14.3127 17 13.3201 17 12.2455V6.88097ZM12 9.49961C12 10.8803 10.8807 11.9996 9.5 11.9996C8.11929 11.9996 7 10.8803 7 9.49961C7 8.1189 8.11929 6.99961 9.5 6.99961C10.8807 6.99961 12 8.1189 12 9.49961Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
    />
  </svg>
</template>
